import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/house-id-logo.svg'
import _imports_1 from '@/assets/icons/house-id-logo2.svg'
import _imports_2 from '@/assets/icons/Google_Play_logo.png'
import _imports_3 from '@/assets/icons/Appstore_logo.png'
import _imports_4 from '@/assets/images/QR-kodOrdnabolån.svg'


const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { class: "card card-feat" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "progress-wrapper" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "border-top border-light pt-3" }
const _hoisted_9 = {
  key: 0,
  class: ""
}
const _hoisted_10 = { class: "alert alert-secondary" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("small", null, " Tack för dina svar. Gå tillbaka till huvudsidan genom att klicka på Mina sidor. ")
], -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Behöver du hjälp med att sälja din bostad?"),
  /*#__PURE__*/_createTextVNode(" Kom i kontakt med en mäklare genom att klicka på Hitta mäklare. ")
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, " Vi vill passa på att tipsa dig om att ladda ner appen House:ID om du vill göra det enkelt att äga din bostad. House:ID är bostadsägarens bästa vän, här samlar du kostnader, kvitton, färgkoder - ja allt som rör ditt boende på ett och samma ställe. Enkelt, säkert och inga dolda avgifter! ", -1)
const _hoisted_17 = {
  key: 0,
  class: "row"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col text-center my-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
  ])
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "row"
}
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"col text-center my-2\"><span><a target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=se.houseid.app\"><img src=\"" + _imports_2 + "\"></a></span><span style=\"padding-left:10px;\"><a target=\"_blank\" href=\"https://apps.apple.com/se/app/house-id-acessa-ditt-hus-id/id1546758051\"><img src=\"" + _imports_3 + "\"></a></span></div>", 1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 2,
  class: "row mt-3 text-center"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, " Ladda ner appen idag! ")
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_34 = {
  key: 0,
  class: "border-top border-light pt-3"
}
const _hoisted_35 = {
  key: 3,
  class: "alert alert-light my-3"
}
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Belopp kvar att fördela: ")
const _hoisted_37 = { class: "border-top border-light pt-3 mt-3" }
const _hoisted_38 = {
  key: 0,
  class: "row align-items-center justify-content-between"
}
const _hoisted_39 = { class: "col-sm-4 col-md-4 d-grid" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Tillbaka till startsidan ")
const _hoisted_41 = { class: "col-sm-4 col-md-4 d-grid" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "12",
  viewBox: "0 0 14 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.289827 6.64289L5.21736 11.4486C5.40326 11.6286 5.65245 11.7309 5.91302 11.7343C6.17502 11.7338 6.42617 11.6311 6.61157 11.4486C6.7989 11.2673 6.90351 11.0188 6.90142 10.76C6.9011 10.5026 6.7968 10.2558 6.61157 10.0743L3.38258 6.93146L12.4145 6.93146C12.9388 6.90344 13.3494 6.47619 13.3494 5.9586C13.3494 5.44101 12.9388 5.01376 12.4145 4.98574L3.37678 4.98574L6.60577 1.84289C6.89676 1.56693 6.98753 1.14391 6.83481 0.775445C6.68209 0.40698 6.3168 0.167625 5.91302 0.171457C5.65358 0.172028 5.40516 0.274915 5.22316 0.457171L0.289827 5.25717C0.104785 5.44115 0.000658035 5.68953 -2.76566e-05 5.9486C-0.00138187 6.2089 0.102996 6.45892 0.289827 6.64289Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Föregående ")
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = { class: "col-sm-4 col-md-4 d-grid" }
const _hoisted_46 = {
  key: 1,
  class: "row"
}
const _hoisted_47 = { class: "col-sm-6 col-md-4 d-grid" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Mina sidor ")
const _hoisted_49 = {
  key: 0,
  class: "col-sm-6 col-md-4 d-grid"
}
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Hitta mäklare ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MortgageQuestionsList = _resolveComponent("MortgageQuestionsList")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requiredSteps, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "progress-step d-grid",
              onClick: ($event: any) => (_ctx.gotoStep(item.key))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["btn btn-sm", {
                'btn-primary': _ctx.currentStepKey == item.key,
                'btn-light':
                  _ctx.currentStepKey != item.key &&
                  _ctx.answeredSteps.indexOf(item.key) === -1,
                'btn-secondary':
                  _ctx.currentStepKey != item.key &&
                  _ctx.answeredSteps.indexOf(item.key) !== -1
              }])
              }, [
                _createElementVNode("span", null, _toDisplayString(index + 1), 1),
                _createElementVNode("small", null, _toDisplayString(item.title), 1)
              ], 2)
            ], 8, _hoisted_5))
          }), 128))
        ]),
        (_ctx.currentStep && _ctx.currentStep.subtitle)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_6, _toDisplayString(_ctx.currentStep.subtitle), 1))
          : _createCommentVNode("", true),
        (_ctx.currentStepKey == 'object' && _ctx.isLoanPurposeRenegotiate)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_7, " Frågorna nedan rör bostaden som du vill omförhandla bolånet på. "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.currentStepKey == 'thankyou')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  (_ctx.form.downPaymentFromHomeSale && !_ctx.isLoanPurposeRenegotiate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.isLoanPurposeRenegotiate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      (_ctx.checkIfMobileDevice)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                        : _createCommentVNode("", true),
                      (_ctx.checkIfMobileDevice)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
                        : _createCommentVNode("", true),
                      (!_ctx.checkIfMobileDevice)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.currentStepKey === 'privateloan')
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.privateLoans, (loan, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      (loan.loanType !== 'Car')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("h4", {
                              class: _normalizeClass({ 'border-top border-light pt-3': index > 0 })
                            }, " Angående ditt lån / din kredit på " + _toDisplayString(loan.amount?.toLocaleString("se")) + " kr ", 3),
                            _createVNode(_component_MortgageQuestionsList, {
                              form: _ctx.form,
                              questions: _ctx.currentStepQuestions,
                              "onUpdate:question": _ctx.onUpdateQuestion,
                              showIndex: _ctx.showIndex,
                              isCoApplicant: _ctx.isCoApplicant,
                              formIndex: index
                            }, null, 8, ["form", "questions", "onUpdate:question", "showIndex", "isCoApplicant", "formIndex"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createVNode(_component_MortgageQuestionsList, {
                    form: _ctx.form,
                    questions: _ctx.currentStepQuestions,
                    "onUpdate:question": _ctx.onUpdateQuestion,
                    showIndex: _ctx.showIndex,
                    isCoApplicant: _ctx.isCoApplicant
                  }, null, 8, ["form", "questions", "onUpdate:question", "showIndex", "isCoApplicant"]),
                  (_ctx.currentStepKey === 'other')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        (_ctx.form.carsInHousehold)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.privateLoans, (loan, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                  (_ctx.isOwnedCar(loan))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                        _createElementVNode("h4", null, [
                                          _createTextVNode(" Bil #" + _toDisplayString(_ctx.getOwnedCarIndex(index)) + " ", 1),
                                          (index > 0)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: ($event: any) => (_ctx.removeOwnedCar(index)),
                                                class: "btn btn-xs btn-outline pull-right"
                                              }, " - Ta bort bil ", 8, _hoisted_32))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_33,
                                        _createVNode(_component_MortgageQuestionsList, {
                                          form: _ctx.form,
                                          questions: _ctx.getOwnedCarsQuestions(loan.carOwnType),
                                          "onUpdate:question": _ctx.onUpdateQuestion,
                                          showIndex: _ctx.showIndex,
                                          formIndex: index
                                        }, null, 8, ["form", "questions", "onUpdate:question", "showIndex", "formIndex"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128)),
                              _createElementVNode("div", null, [
                                (_ctx.ownedCars.length < 2)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addOwnedCar && _ctx.addOwnedCar(...args))),
                                      class: "btn btn-xs btn-outline"
                                    }, " + Lägg till bil "))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.housingsToKeep, (housing, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            (housing.keepCurrentHousing)
                              ? (_openBlock(), _createElementBlock("h4", _hoisted_34, " Övrig bostad, " + _toDisplayString(_ctx.getHousingText(housing.housing)), 1))
                              : _createCommentVNode("", true),
                            (housing.keepCurrentHousing)
                              ? (_openBlock(), _createBlock(_component_MortgageQuestionsList, {
                                  key: 1,
                                  form: _ctx.form,
                                  questions: _ctx.housingQuestions,
                                  "onUpdate:question": _ctx.onUpdateQuestion,
                                  showIndex: _ctx.showIndex,
                                  isCoApplicant: _ctx.isCoApplicant,
                                  formIndex: index
                                }, null, 8, ["form", "questions", "onUpdate:question", "showIndex", "isCoApplicant", "formIndex"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])),
          (_ctx.currentStepKey === 'downpayment1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("strong", null, _toDisplayString(_ctx.downPaymentToEnter.toLocaleString("sv")) + " kr", 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_37, [
          (_ctx.currentStepKey !== 'thankyou')
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_router_link, {
                    to: { name: 'mortgage_index' },
                    class: "btn btn-secondary my-2"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_40
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_41, [
                  (!_ctx.isFirstStep)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-outline my-2",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPreviousStep && _ctx.onPreviousStep(...args)))
                      }, _hoisted_44))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onNextStep && _ctx.onNextStep(...args)))
                  }, "Spara")
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentStepKey === 'thankyou')
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_router_link, {
                    class: "btn btn-primary",
                    to: { name: 'mortgage_index' }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_48
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.form.downPaymentFromHomeSale)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createVNode(_component_router_link, {
                        class: "btn btn-secondary",
                        to: { name: 'customer_offer_index' }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_50
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}